import { useRef as d, useEffect as S, useMemo as V, useCallback as M } from "react";
import "./useResizeDetector-1ae5f4fb.js";
import { l as A } from "./lodash-26d68caa.js";
import { usePercentageValueInPixels as L } from "./table/BironTable.utils.js";
const N = (n) => {
  const r = d();
  return S(() => {
    r.current = n;
  }), r.current;
};
function k(n, r, t) {
  var l = this, a = d(null), f = d(0), e = d(null), u = d([]), c = d(), s = d(), v = d(n), m = d(!0);
  v.current = n;
  var x = typeof window < "u", p = !r && r !== 0 && x;
  if (typeof n != "function")
    throw new TypeError("Expected a function");
  r = +r || 0;
  var w = !!(t = t || {}).leading, D = !("trailing" in t) || !!t.trailing, g = "maxWait" in t, E = "debounceOnServer" in t && !!t.debounceOnServer, I = g ? Math.max(+t.maxWait || 0, r) : null;
  S(function() {
    return m.current = !0, function() {
      m.current = !1;
    };
  }, []);
  var W = V(function() {
    var C = function(o) {
      var i = u.current, h = c.current;
      return u.current = c.current = null, f.current = o, s.current = v.current.apply(h, i);
    }, y = function(o, i) {
      p && cancelAnimationFrame(e.current), e.current = p ? requestAnimationFrame(o) : setTimeout(o, i);
    }, P = function(o) {
      if (!m.current)
        return !1;
      var i = o - a.current;
      return !a.current || i >= r || i < 0 || g && o - f.current >= I;
    }, T = function(o) {
      return e.current = null, D && u.current ? C(o) : (u.current = c.current = null, s.current);
    }, O = function o() {
      var i = Date.now();
      if (P(i))
        return T(i);
      if (m.current) {
        var h = r - (i - a.current), B = g ? Math.min(h, I - (i - f.current)) : h;
        y(o, B);
      }
    }, b = function() {
      if (x || E) {
        var o = Date.now(), i = P(o);
        if (u.current = [].slice.call(arguments), c.current = l, a.current = o, i) {
          if (!e.current && m.current)
            return f.current = a.current, y(O, r), w ? C(a.current) : s.current;
          if (g)
            return y(O, r), C(a.current);
        }
        return e.current || y(O, r), s.current;
      }
    };
    return b.cancel = function() {
      e.current && (p ? cancelAnimationFrame(e.current) : clearTimeout(e.current)), f.current = 0, u.current = a.current = c.current = e.current = null;
    }, b.isPending = function() {
      return !!e.current;
    }, b.flush = function() {
      return e.current ? T(Date.now()) : s.current;
    }, b;
  }, [w, g, r, I, D, p, x, E]);
  return W;
}
const F = (n, r) => {
  var t;
  return n.length > 0 ? ((t = A.deburr(r)) == null ? void 0 : t.toLowerCase().indexOf(A.deburr(n).toLowerCase())) ?? -1 : -1;
}, z = (n, r, t, l) => {
  const a = N(n), f = M(() => {
    l(n && n.length > 0 ? t.filter((u) => r.find((c) => {
      var s;
      return c.length === 1 ? F(n, u[c[0]]) !== -1 : F(n, (s = u[c[0]]) == null ? void 0 : s[c[1]]) !== -1;
    })) : t);
  }, [t, r, n, l]), e = k(f, 350);
  S(() => {
    n !== a && e();
  }, [e, t, r, n, l, a]);
}, q = () => M((n, r) => {
  let t = n;
  return r.forEach((l) => {
    t = t[l];
  }), t;
}, []), H = (n, r, t, l, a) => {
  const f = q(), e = L(l, a);
  return V(() => n.map((u) => {
    const { width: c } = u, s = typeof c == "string" && c.indexOf("%") !== -1 ? e(Number(`${c}`.substring(0, c.indexOf("%")))) : Number(c);
    return {
      ...u,
      width: r ? s : c,
      sorter: u.dataIndex && t ? {
        compare: (v, m) => {
          const x = A.isArray(u.dataIndex) ? u.dataIndex : [u.dataIndex], p = f(v, x), w = f(m, x);
          return String(p).localeCompare(String(w));
        }
      } : u.sorter
    };
  }), [n, e, r, t, f]);
}, J = (n, r) => V(() => r ?? n * 120, [n, r]);
export {
  J as a,
  H as b,
  k as c,
  F as i,
  z as u
};
//# sourceMappingURL=BironTable.hooks-d48a6f88.js.map
